import {isEmpty, map} from 'lodash';

import {LiveHelpMessageSettings, LiveHelpSettings, TextChatContentType} from 'types';

import {FormFields, LiveHelpAutoReplyFields, LiveHelpMessagesFields, MessageItem, MessageType, SectionName} from './types';

const SETTINGS_MAP = {
    [MessageType.Text]: TextChatContentType.Text,
    [MessageType.InteractiveChat]: TextChatContentType.InteractiveChat
};

const MESSAGE_MAP = {
    [TextChatContentType.Text]: MessageType.Text,
    [TextChatContentType.InteractiveChat]: MessageType.InteractiveChat
};

const toMessagesSettings = (messages: MessageItem[]): LiveHelpMessageSettings[] => map(messages, (m) => ({
    content: m.text,
    contentType: SETTINGS_MAP[m.type],
    ...(!isEmpty(m.data) && {data: m.data})
}));

const fromMessagesSettings = (messages: LiveHelpMessageSettings[]): MessageItem[] => map(messages, (m) => ({
    text: m.content,
    type: MESSAGE_MAP[m.contentType],
    ...(!isEmpty(m.data) && {data: m.data})
}));

const toPartialSectionSettings = (section: SectionName, values: LiveHelpMessagesFields | LiveHelpAutoReplyFields) => {
    if (section === SectionName.Welcome) {
        return {messages: toMessagesSettings((values as LiveHelpMessagesFields).messages)};
    }

    if (section === SectionName.AvatarWelcome) {
        return {messages: toMessagesSettings((values as LiveHelpMessagesFields).messages)};
    }

    if (section === SectionName.Deescalate) {
        return {messages: toMessagesSettings((values as LiveHelpMessagesFields).messages)};
    }

    if (section === SectionName.AutoReply) {
        return {
            agentsAvailable: {
                messages: toMessagesSettings((values as LiveHelpAutoReplyFields).agentsAvailable.messages)
            },
            agentsUnavailable: {
                messages: toMessagesSettings((values as LiveHelpAutoReplyFields).agentsUnavailable.messages)
            }
        };
    }

    throw new Error(`Unsupported section ${section}`);
};

const toPartialSettings = (section: SectionName, values: LiveHelpMessagesFields | LiveHelpAutoReplyFields): Partial<LiveHelpSettings> => {
    const sectionSettings = toPartialSectionSettings(section, values);
    return {
        widget: {
            [section]: sectionSettings
        }
    };
};

const fromSettings = (settings: LiveHelpSettings): FormFields => ({
    [SectionName.Welcome]: {
        messages: fromMessagesSettings(settings?.widget?.welcome?.messages)
    },
    [SectionName.AvatarWelcome]: {
        messages: fromMessagesSettings(settings?.widget?.avatarWelcome?.messages)
    },
    [SectionName.Deescalate]: {
        messages: fromMessagesSettings(settings?.widget?.deescalate?.messages)
    },
    [SectionName.AutoReply]: {
        agentsAvailable: {
            messages: fromMessagesSettings(settings?.widget?.autoReply?.agentsAvailable?.messages)
        },
        agentsUnavailable: {
            messages: fromMessagesSettings(settings?.widget?.autoReply?.agentsUnavailable?.messages)
        },
    }
});

export const mapper = {
    fromSettings,
    toPartialSettings
};